import Svg, { SvgProps } from './Svg';

export default function UpgradeIcon({ ...props }: SvgProps) {
  return (
    <Svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M8 0.986328L13.4454 6.4317C13.7383 6.72459 13.7383 7.19946 13.4454 7.49236C13.1525 7.78525 12.6776 7.78525 12.3847 7.49236L8.75 3.35394L8.75 11.25C8.75 11.6642 8.41421 12 8 12C7.58579 12 7.25 11.6642 7.25 11.25L7.25 3.35394L3.61529 7.49236C3.3224 7.78525 2.84752 7.78525 2.55463 7.49236C2.26174 7.19946 2.26174 6.72459 2.55463 6.4317L8 0.986328Z"
        fill="white"></path>
      <path
        d="M2.05078 14.2422C2.05078 13.828 2.38657 13.4922 2.80078 13.4922H13.1992C13.6134 13.4922 13.9492 13.828 13.9492 14.2422C13.9492 14.6564 13.6134 14.9922 13.1992 14.9922H2.80078C2.38657 14.9922 2.05078 14.6564 2.05078 14.2422Z"
        fill="white"></path>
    </Svg>
  );
}
